import api from '@/services/Api';
import Patientengruppe from '@/types/Patientengruppe';
import { ActionContext, Module } from 'vuex';
import { PatientengruppenState, RootState } from '@/store/types';

type Context = ActionContext<PatientengruppenState, RootState>;

export const patientengruppen: Module<PatientengruppenState, RootState> = {
    namespaced: true,
    state: {
        dialogs: {
            edit: false,
        },
        loaders: {
            save: false,
            delete: false,
            gruppen: false,
            printers: false,
        },
        gruppen: [],
    },
    actions: {
        loadPatientengruppen({ commit, rootState }: Context): void {
            commit('setLoadersPatientengruppen', true);

            api.post('verwaltung/patientengruppen/load')
                .then((response) => commit('setPatientengruppen', response.data.body))
                .catch(console.error)
                .finally(() => commit('setLoadersPatientengruppen', false));
        },
    },
    mutations: {
        setPatientengruppen(state: PatientengruppenState, payload: Patientengruppe[]): void {
            state.gruppen = payload.map((data: Patientengruppe) => new Patientengruppe(data));
        },
        setDialogsDetail(state: PatientengruppenState, visible: boolean): void {
            state.dialogs.edit = visible;
        },
        setLoadersSave(state: PatientengruppenState, loading: boolean): void {
            state.loaders.save = loading;
        },
        setLoadersDelete(state: PatientengruppenState, loading: boolean): void {
            state.loaders.delete = loading;
        },
        setLoadersPatientengruppen(state: PatientengruppenState, loading: boolean): void {
            state.loaders.gruppen = loading;
        },
        setLoadersPrinters(state: PatientengruppenState, loading: boolean): void {
            state.loaders.printers = loading;
        },
    },
};
